import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var BanquetIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M6.792 3.405a1.1 1.1 0 101.905-1.1 1.1 1.1 0 00-1.905 1.1zM3.1 5.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM18.54 13.053a1.1 1.1 0 11-1.1-1.906 1.1 1.1 0 011.1 1.906zM13.345 14.445a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z"
                        }),
                        _jsx("path", {
                            d: "M16.745 13.245a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm0 2a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M20.436 14.95a1.1 1.1 0 101.906 1.1 1.1 1.1 0 00-1.905-1.1zM19.045 20.145a1.1 1.1 0 112.2 0 1.1 1.1 0 01-2.2 0zM16.453 20.84a1.1 1.1 0 10-1.905 1.1 1.1 1.1 0 001.905-1.1zM12.65 17.037a1.1 1.1 0 11-1.1 1.905 1.1 1.1 0 011.1-1.905z"
                        }),
                        _jsx("path", {
                            d: "M3 7.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zm5 0a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M10.595 7.208a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM9.9 9.8a1.1 1.1 0 100 2.2 1.1 1.1 0 000-2.2zM4.706 11.192a1.1 1.1 0 111.1 1.905 1.1 1.1 0 01-1.1-1.905zM2.808 9.294a1.1 1.1 0 10-1.905-1.1 1.1 1.1 0 001.905 1.1z"
                        })
                    ]
                })
            })
        ]
    });
};
BanquetIcon.isCarinaIcon = true;
export default BanquetIcon;
